import { Routes, Route, Navigate } from "react-router-dom";
import { useTabs } from "@/context/TabsContext";
import Dashboard from "@/pages/Dashboard";
import Calendario from "@/pages/Calendario";
import Pacientes from "@/pages/Pacientes";
import PacienteDetalle from "@/pages/PacienteDetalle";
import Caja from "@/pages/Caja";
import Ajustes from "@/pages/Ajustes";
import Contabilidad from "@/pages/Contabilidad";

/**
 * Renders ALL open tabs always-mounted; toggles visibility via display:none.
 * Each tab uses <Routes location={tab.path}> so its `useParams`/matching is locked
 * to that tab's URL even when the actual location.pathname is different.
 */
export default function TabContent() {
  const { tabs, activeId } = useTabs();
  return (
    <div className="relative" data-testid="tab-content">
      {tabs.map((t) => {
        const visible = t.id === activeId;
        return (
          <div
            key={t.id}
            data-tab-id={t.id}
            style={{ display: visible ? "block" : "none" }}
            aria-hidden={!visible}
          >
            <Routes location={t.path}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/agenda" element={<Calendario />} />
              <Route path="/pacientes" element={<Pacientes />} />
              <Route path="/pacientes/:id" element={<PacienteDetalle />} />
              <Route path="/caja" element={<Caja />} />
              <Route path="/contabilidad" element={<Contabilidad />} />
              <Route path="/reportes" element={<Navigate to="/contabilidad" replace />} />
              <Route path="/ajustes" element={<Ajustes />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        );
      })}
    </div>
  );
}
